
@if (isLoading) {
  <div class="bg-white rounded-lg p-6 shadow-sm">
    <h2 class="text-xl font-semibold text-gray-800 mb-6">Información de Pago</h2>
    <div class="space-y-4">
      <ngx-skeleton-loader [count]="1" [theme]="{ height: '24px', width: '12rem', 'border-radius': '0.5rem' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [count]="1" [theme]="{ height: '64px', width: '100%', 'border-radius': '0.75rem' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [count]="3" [theme]="{ height: '40px', width: '100%', 'border-radius': '0.5rem' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [count]="5" [theme]="{ height: '40px', width: '100%', 'border-radius': '0.5rem' }"></ngx-skeleton-loader>
      <ngx-skeleton-loader [count]="1" [theme]="{ height: '56px', width: '100%', 'border-radius': '0.5rem' }"></ngx-skeleton-loader>
    </div>
  </div>
} @else {
  <div class="bg-white rounded-lg p-6 shadow-sm">
    <h2 class="text-xl font-semibold text-gray-800 mb-6">Información de Pago</h2>

    <!-- Tarjeta de Crédito -->
    <div class="flex items-center justify-between mb-6 p-4 bg-gray-50 rounded-lg">
      <div class="flex items-center space-x-3">
        <div class="bg-yellow-500 p-3 rounded-lg">
          <i class="fas fa-credit-card text-white text-xl"></i>
        </div>
        <div>
          <h3 class="font-medium text-gray-800">{{ infoPayment.payment }}</h3>
        </div>
      </div>
      <span
        class="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium"
      >
        Pagado
      </span>
    </div>

    <!-- Desglose del pago -->
    <div class="mb-6">
      <h3 class="text-lg font-medium text-gray-800 mb-4">Desglose del pago</h3>
      <div class="space-y-3">
        @if (infoPayment.creditAmount > 0) {
        <div class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded-md">
          <span class="text-gray-600 flex items-center">
            <i class="fas fa-credit-card text-gray-400 mr-2"></i>
            Créditos
          </span>
          <span class="font-medium text-gray-800">{{
            infoPayment.creditAmount | currency : "MXN " : "symbol" : "1.2-2"
          }}</span>
        </div>
        }
        @if (infoPayment.cardAmount > 0) {
        <div class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded-md">
          <span class="text-gray-600 flex items-center">
            <i class="fas fa-id-card text-gray-400 mr-2"></i>
            Tarjeta
          </span>
          <span class="font-medium text-gray-800">{{
            infoPayment.cardAmount | currency : "MXN " : "symbol" : "1.2-2"
          }}</span>
        </div>
        }
        @if (infoPayment.cashAmount > 0) {
        <div class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded-md">
          <span class="text-gray-600 flex items-center">
            <i class="fas fa-money-bill-wave text-gray-400 mr-2"></i>
            Efectivo
          </span>
          <span class="font-medium text-gray-800">{{
            infoPayment.cashAmount | currency : "MXN " : "symbol" : "1.2-2"
          }}</span>
        </div>
        }
      </div>
    </div>

    <!-- Detalles financieros de la orden -->
    <div class="mb-6">
      <h3 class="text-lg font-medium text-gray-800 mb-4">
        Detalles de la orden:
      </h3>
      <div class="space-y-3">
        <div
          class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded-md"
        >
          <span class="text-gray-600 flex items-center">
            <i class="fas fa-mobile text-gray-400 mr-2"></i>
            Subtotal
          </span>
          <span class="font-medium text-gray-800">{{
            infoPayment.totalOrden | currency : "MXN " : "symbol" : "1.2-2"
          }}</span>
        </div>
        <!-- Costo de envío -->
        <div
          class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded-md"
        >
          <span class="text-gray-600 flex items-center">
            <i class="fas fa-truck text-gray-400 mr-2"></i>
            Costo de envío
          </span>
          <span class="font-medium text-gray-800">{{
            infoPayment.costo_envio | currency : "MXN " : "symbol" : "1.2-2"
          }}</span>
        </div>
        <!-- Tarifa base -->
        <!-- <div
          class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded-md"
        >
          <span class="text-gray-600 flex items-center">
            <i class="fas fa-motorcycle text-gray-400 mr-2"></i>
            Tarifa base
          </span>
          <span class="font-medium text-gray-800">{{
            infoPayment.baseRate | currency : "MXN " : "symbol" : "1.2-2"
          }}</span>
        </div> -->
           <!--     Tarifa de  servicio -->
        <div
          class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded-md"
        >
          <span class="text-gray-600 flex items-center">
            <i class="fas fa-genderless text-gray-400 mr-2"></i>
            Tarifa de  servicio
          </span>
          <span class="font-medium text-gray-800">{{
            infoPayment.serviceRate | currency : "MXN " : "symbol" : "1.2-2"
          }}</span>
        </div>
        <!-- Propina (Baksheesh) -->
        <div
          class="flex justify-between items-center py-2 px-3 bg-gray-50 rounded-md"
        >
          <span class="text-gray-600 flex items-center">
            <i class="fas fa-hand-holding-usd text-gray-400 mr-2"></i>
            Propina
          </span>
          <span class="font-medium text-gray-800">{{
            infoPayment.baksheesh | currency : "MXN " : "symbol" : "1.2-2"
          }}</span>
        </div>

        <!-- Total de la orden -->
        <div
          class="flex justify-between items-center py-3 px-3 bg-yellow-50 rounded-md border border-yellow-200"
        >
          <span class="text-yellow-700 flex items-center font-medium">
            <i class="fas fa-receipt text-yellow-500 mr-2"></i>
            Total de la orden
          </span>
          <span class="font-bold text-yellow-700 text-lg">{{
            totalOrden() | currency : "MXN " : "symbol" : "1.2-2"
          }}</span>
        </div>
      </div>
    </div>

    <!-- Otros métodos disponibles -->
    <!-- <div class="mb-6">
      <h3 class="text-lg font-medium text-gray-800 mb-4">
        Otros métodos disponibles:
      </h3>
      <div class="flex space-x-4">
        <button
          class="flex items-center space-x-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
        >
          <i class="fas fa-coins text-green-600"></i>
          <span class="text-gray-700">Créditos</span>
        </button>
      </div>
    </div> -->
  </div>
}

